import * as _ from "lodash";
import {BaseAccountOverviewView, BaseAccountViewOptions} from "../_BaseAccountViews";
import {StatusNotificationCollection} from "../../../collections/StatusNotifications";
import {
    InstallDashboardView,
    InstallModuleView,
    InstallNotificationView,
    InstallTeamView,
    InstallUserView
} from "./InstallDetailViews";
import {Install} from "../../../models/Install";


export class InstallOverviewView extends BaseAccountOverviewView {

    private currentInstall: Install;
    private statusNotificationCollections: { [groupId: number]: StatusNotificationCollection } = {};

    constructor(options: BaseAccountViewOptions) {
        super(<any> _.extend({}, options, {
            tagName: 'div',
            events: {
                'submit .account-modify-team-settings-form': 'handleTeamSettingsSubmitButton',
                'click .add-user-button': 'handleCreateUserButtonClick',
                'click .delete-user-group-user': 'handleDeleteUserGroupUser',
            }
        }));
    }

    show(installId, detail?, subDetail?) {
        this.currentDetail = detail;
        this.currentInstall = this.options.installCollection.findWhere({
            id: Number(installId),
            organization_id: this.options.currentOrganizationId
        });

        this.collectionLoaded = true;
        this.render();

        // If there is a detail render it exclusively
        if (detail) {
            this.renderSubViews(detail, false);
            return;
        }

        // Otherwise render all details
        _.each(['teams', 'users', 'dashboards', 'modules', 'notifications'], (viewClass) => {
            this.renderSubViews(viewClass, true);
        });
    }

    render() {
        this.$el.html(this.template({
            collectionLoaded: this.collectionLoaded,
            title: this.currentInstall ? this.currentInstall.getDisplayName() : '',
            canView: true
        }));

        this.showBreadcrumbs();
        (<any> this.$('input[type="checkbox"]')).bootstrapToggle();
        this.delegateEvents();
        return this;
    }

    showBreadcrumbs() {
        if (!this.options.currentOrganizationId || !this.currentInstall) return;
        var orgId = this.options.currentOrganizationId;
        var installId = this.currentInstall.get('id');
        /**/
        var routeString = '/#/account/' + orgId + '/installs/' + installId;
        this.breadcrumbPathMap = {
            [this.currentOrganization.get('name')]: '/#/account/' + orgId,
            'Installations': '/#/account/' + orgId + '/installs'
        };

        var currentPath, searchByX;
        if (this.currentDetail) {
            this.breadcrumbPathMap[this.currentInstall.getDisplayName()] = routeString;

            searchByX = 'Installation Details';
            this.breadcrumbDropDownOptions = {
                'Users': routeString + '/users',
                'Teams': routeString + '/teams',
                'Dashboards': routeString + '/dashboards',
                'Modules': routeString + '/modules',
                'Notifications': routeString + '/notifications',
            };
            currentPath = _.capitalize(this.currentDetail);
        } else {
            searchByX = 'Installation';
            currentPath = this.currentInstall.getDisplayName();
            this.options.installCollection.each((i) => {
                if (i.get('organization_id') !== orgId) return;
                this.breadcrumbDropDownOptions[i.getDisplayName()] = '/#/account/' + orgId + '/installs/' + i.get('id');
            });
        }
        super.showBreadcrumbs(currentPath, searchByX);
    }

    renderSubViews(detail, isOverview) {
        var options = {
            statusNotificationCollections: this.statusNotificationCollections,
            groupPermissionCollections: this.groupPermissionCollections,
            currentInstall: this.currentInstall,
            isOverview: isOverview
        };

        var subview;
        switch (detail) {
            case 'teams':
                subview = new InstallTeamView(_.extend({}, this.options, options));
                break;
            case 'users':
                subview = new InstallUserView(_.extend({}, this.options, options));
                break;
            case 'dashboards':
                subview = new InstallDashboardView(_.extend({}, this.options, options));
                break;
            case 'modules':
                subview = new InstallModuleView(_.extend({}, this.options, options));
                break;
            case 'notifications':
                subview = new InstallNotificationView(_.extend({}, this.options, options));
                break;
        }

        if (subview) {
            this.subViews.push(subview);
            this.$('.container').append(subview.render().$el);
            subview.show();
        }
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/views/account/installs/InstallOverviewView.ts